import { makeStyles, Theme } from "@material-ui/core/styles";
import { lightGrey } from "../../../../../../../infrastructure/theme/customColors";

interface Props {
  multiple: boolean;
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
  approversSeparator: {
    height: "1px",
    width: "100%",
    backgroundColor: "#CFDAE5",
    marginTop: theme.spacing(1),
    marginBottom: "12px",
  },
  approversContainer: {
    width: "430px",
    height: ({ multiple }) => (multiple ? "116px" : "60px"),
    borderRadius: "4px",
    backgroundColor: lightGrey,
    marginLeft: "auto",
    padding: "16px",
  },
  approverType: {
    lineHeight: "16px",
  },
  approverEmail: {
    marginLeft: "auto",
  },
  dateLabel: {
    fontSize: "10px",
    color: "#929FAD",
    marginTop: "4px",
    lineHeight: "11px",
  },
}));

export default useStyles;
